/** API paths for the Descope service APIs */
export default {
  accessKey: {
    exchange: '/v1/auth/accesskey/exchange',
  },
  otp: {
    verify: '/v1/auth/otp/verify',
    signIn: '/v1/auth/otp/signin',
    signUp: '/v1/auth/otp/signup',
    update: {
      email: '/v1/auth/otp/update/email',
      phone: '/v1/auth/otp/update/phone',
    },
    signUpOrIn: '/v1/auth/otp/signup-in',
  },
  magicLink: {
    verify: '/v1/auth/magiclink/verify',
    signIn: '/v1/auth/magiclink/signin',
    signUp: '/v1/auth/magiclink/signup',
    update: {
      email: '/v1/auth/magiclink/update/email',
      phone: '/v1/auth/magiclink/update/phone',
    },
    signUpOrIn: '/v1/auth/magiclink/signup-in',
  },
  enchantedLink: {
    verify: '/v1/auth/enchantedlink/verify',
    signIn: '/v1/auth/enchantedlink/signin',
    signUp: '/v1/auth/enchantedlink/signup',
    session: '/v1/auth/enchantedlink/pending-session',
    update: {
      email: '/v1/auth/enchantedlink/update/email',
    },
    signUpOrIn: '/v1/auth/enchantedlink/signup-in',
  },
  oauth: {
    start: '/v1/auth/oauth/authorize',
    exchange: '/v1/auth/oauth/exchange',
    startNative: 'v1/auth/oauth/native/start',
    finishNative: 'v1/auth/oauth/native/finish',
    oneTap: {
      getOneTapClientId: '/v1/auth/onetap/clientid/{provider}',
      exchangeOneTapIDToken: '/v1/auth/onetap/idtoken/exchange',
      verifyOneTapIDToken: '/v1/auth/onetap/idtoken/verify',
    },
  },
  outbound: {
    connect: '/v1/outbound/oauth/connect',
  },
  saml: {
    start: '/v1/auth/saml/authorize',
    exchange: '/v1/auth/saml/exchange',
  },
  totp: {
    verify: '/v1/auth/totp/verify',
    signUp: '/v1/auth/totp/signup',
    update: '/v1/auth/totp/update',
  },
  notp: {
    signIn: '/v1/auth/notp/whatsapp/signin',
    signUp: '/v1/auth/notp/whatsapp/signup',
    signUpOrIn: '/v1/auth/notp/whatsapp/signup-in',
    session: '/v1/auth/notp/pending-session',
  },
  webauthn: {
    signUp: {
      start: '/v1/auth/webauthn/signup/start',
      finish: '/v1/auth/webauthn/signup/finish',
    },
    signIn: {
      start: '/v1/auth/webauthn/signin/start',
      finish: '/v1/auth/webauthn/signin/finish',
    },
    signUpOrIn: {
      start: '/v1/auth/webauthn/signup-in/start',
    },
    update: {
      start: 'v1/auth/webauthn/update/start',
      finish: '/v1/auth/webauthn/update/finish',
    },
  },
  password: {
    signUp: '/v1/auth/password/signup',
    signIn: '/v1/auth/password/signin',
    sendReset: '/v1/auth/password/reset',
    update: '/v1/auth/password/update',
    replace: '/v1/auth/password/replace',
    policy: '/v1/auth/password/policy',
  },
  // NOTE: When adding routes that validate session state (like refresh, me, etc.),
  // consider adding them to SESSION_VALIDATION_ROUTES in web-js-sdk/src/enhancers/helpers/index.ts
  // These routes trigger logout/clear tokens on failure, unlike OTP routes that may fail for invalid input
  refresh: '/v1/auth/refresh',
  tryRefresh: '/v1/auth/try-refresh',
  selectTenant: '/v1/auth/tenant/select',
  logout: '/v1/auth/logout',
  logoutAll: '/v1/auth/logoutall',
  me: '/v1/auth/me',
  myTenants: '/v1/auth/me/tenants',
  history: '/v1/auth/me/history',
  flow: {
    start: '/v1/flow/start',
    next: '/v1/flow/next',
  },
};
